import { render } from "./AtendimentoSituacaoAgendamentoRelatorio.vue?vue&type=template&id=b64393ee&scoped=true"
import script from "./AtendimentoSituacaoAgendamentoRelatorio.vue?vue&type=script&lang=js"
export * from "./AtendimentoSituacaoAgendamentoRelatorio.vue?vue&type=script&lang=js"

import "./AtendimentoSituacaoAgendamentoRelatorio.vue?vue&type=style&index=0&id=b64393ee&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b64393ee"]])

export default __exports__